import { Button, Tooltip } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";

/**
 * The single green "export to excel" action, used across the app.
 *
 * It exists so the button cannot drift again: size, tone and icon are fixed
 * here rather than being re-specified at every call site, which is how the
 * variants (small / large / different greens) crept in.
 */
const ExcelButton = ({
  loading = false,
  disabled = false,
  onClick,
  tooltip = "خروجی اکسل",
  label,
  className = "",
  ...rest
}) => {
  const button = (
    <Button
      type="primary"
      icon={<FileExcelOutlined />}
      className={`excel-btn ${className}`}
      aria-label={label || tooltip}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {label}
    </Button>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};

export default ExcelButton;
